import moment from 'moment';

const generateWeekData = () => {
  const weekData = [];

  // Start date
  let startDate = new Date("April 1, 2023");

  for (let i = 0; i < 50; i++) {
    // Format the date
    const formattedDate = startDate.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });

    const week = {
      date: formattedDate,
      data: [
        {
          AppID: `123-456-789-${i}`,
          VehChassisNo: ["SGT8888H", `Mercedes-Benz-S-Class S400L Hybrid ${i}`],
          LoanAmt: 26000.0,
          LoanInt: 1.25,
          LoanProductName: "OCBC Premium",
          Remarks:'',
          Action: false,
        },
        {
          AppID: `123-456-789-${i}`,
          VehChassisNo: ["SGT8888H", `Mercedes-Benz-S-Class S400L Hybrid ${i}`],
          LoanAmt: 26000.0,
          LoanInt: 1.25,
          LoanProductName: "OCBC Premium",
          Remarks:'High levels of existing debt, such as credit card balances or other loans.',
          Action: true,
        },
        {
          AppID: `123-456-789-${i}`,
          VehChassisNo: ["SGT8888H", `Mercedes-Benz-S-Class S400L Hybrid ${i}`],
          LoanAmt: 26000.0,
          LoanInt: 1.25,
          LoanProductName: "OCBC Premium",
          Remarks:'',
          Action: false,
        },
        {
          AppID: `123-456-789-${i}`,
          VehChassisNo: ["SGT8888H", `Mercedes-Benz-S-Class S400L Hybrid ${i}`],
          LoanAmt: 26000.0,
          LoanInt: 1.25,
          LoanProductName: "OCBC Premium",
          Remarks:'',
          Action: false,
        },
      ],
    };

    weekData.push(week);

    // Increment the date by 7 days (a week)
    startDate.setDate(startDate.getDate() + 7);
  }

  return weekData;
};

export const WeekDataSource = generateWeekData();

export const BonusSummary = [
  {
    key: "1",
    week_loan_amt: {
      achievedValue: 250000,
      targetValue: 300000,
      stepData: [
        { text: "Progress", label: "0%", value: 0 },
        { text: "Tier 1", label: "$100k", value: 0 },
        { text: "Tier 2", label: "$200k", value: 0 },
        { text: "Tier 3", label: "$300k", value: 0 },
      ],
    },
  },
];

export const TierList = [
  {
    tier: "Tier 1",
    bonusAmount: "$100",
    qualifyingAmount: "$10000 to $100000",
  },
  {
    tier: "Tier 2",
    bonusAmount: "$150",
    qualifyingAmount: "$10000 to $100000",
  },
  {
    tier: "Tier 3",
    bonusAmount: "$200",
    qualifyingAmount: "$10000 to $100000",
  },
];



export const generatePaymentHistoryData = () => {
  const data = [];

  for (let i = 0; i < 20; i++) {
    const entry = {
      date: moment().subtract(i, 'days').format(),
      bonusPayableAmount: Math.floor(Math.random() * 10000) + 1000,
      remarks: "Excellent performance",
      document: "public/uploads/loan_application/65547463ea1d2.png",
    };

    data.push(entry);
  }

  return data;
};

export const PaymentHistoryData = generatePaymentHistoryData();